import { observable, action } from "mobx";
import UsuarioService from "../../../services/UsuarioService";
import TarefaService from "../../../services/TarefaService";
import {getByAtribute} from "../../../utils/formatar";
import EmpregadoService from "../../../services/EmpregadoService";
import {computed} from "mobx/lib/mobx";
import TimesheetService from "../../../services/TimesheetService";
import FluxoService from "../../../services/FluxoService";

export default class TabelaFluxoStore {
    @observable usuarioDelegadoLogin;
    @observable tableRef;
    @observable idSolicitacaoBloqueandoAprovacaoLote;
    @observable temTarefaQuePodeInserirAprovadorExtra;
    @observable observacoes;
    @observable matriculaAprovadoresExtra;
    @observable empregadosFiltrados;
    @observable tarefasComAprovadoresExtra;
    @observable todosAprovadores;
    @observable loadingAprovadores;

    constructor(loginStore) {
        this.loginStore = loginStore;
        this.idSolicitacaoBloqueandoAprovacaoLote = null;
        this.temTarefaQuePodeInserirAprovadorExtra = false;
        this.usuarioDelegadoLogin = "";
        this.tableRef = null;
        this.observacoes = "";
        this.matriculaAprovadoresExtra = [""];
        this.empregadosFiltrados = [];
        this.tarefasComAprovadoresExtra = "";
        this.todosAprovadores = [];
        this.loadingAprovadores = false;

        this.usuarioService = new UsuarioService();
        this.empregadoService = new EmpregadoService();
        this.tarefaService = new TarefaService();
        this.timesheetService = new TimesheetService();
        this.fluxoService = new FluxoService();
    }

    setUsuarioDelegado(value) {
        this.usuarioDelegadoLogin = value;
    }

    adquirirSelecionados() {
        //TODO:
    }

    migrarSelecionados(listaCompleta) {
        const selectedKeys = new Set(this.tableRef.state.selectedRowKeys);
        const listaSelecionados = listaCompleta.filter(item => selectedKeys.has(item.idSolicitacaoExibicao) && !item.fluxoNovo);

        return this.fluxoService.migrarFluxo(listaSelecionados);
    }


    setTableRef(ref) {
        this.tableRef = ref;
    }

    filtrarAprovadoresExtra(input, callback) {
        if (input && input.length > 2){
            this.empregadoService.filtrarGestoresPorNh(input).then(response =>{
                callback(null, {
                    options: response.data.map(aprovador => {
                        return {"value":aprovador.value, "label": aprovador.label};
                    }),
                    complete: false
                });

            }).catch(error =>{
                callback(null, {
                    options: [],
                    complete: false
                });
                console.log(error);
            })
        }else {
            callback(null, {options: [], complete: false});
        }
    }

    filtrarUsuarios(input, callback) {
        this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
            if(response && response.length > 0) {
                this.empregadosFiltrados.push(...response);
            }
            callback(null, {
                options: response.map(empregado => {
                    const cpf = !!empregado.cpf ?  " ("+empregado.cpf+")" : "";
                    return {value: input, label: empregado.matricula + " - " + empregado.nome + cpf};
                }),
                complete: false
            });
        }).catch(error => {
            callback(null, {
                options: [],
                complete: false
            });
        });
    }

    _filtrarUsuariosPorNome(input, callback) {
        let result = [];
        if(input && input.length > 1) {
            this.usuarioService.filterByName(input).then(response => {
                if(response.data) {
                    response.data.map(usuario => {
                        result.push({value: usuario.login, label: usuario.nome});
                    });
                }
                callback(null, {
                    options: result,
                    complete: false
                });
            });
        } else {
            callback(null, {
                options: result,
                complete: false
            });
        }
    }

    delegarSelecionados(lista) {
//        return this.tarefaService.delegar(this.tableRef.state.selectedRowKeys, this.usuarioDelegadoLogin)
        const selectedKeys = new Set(this.tableRef.state.selectedRowKeys);
        let listaSelecionados = lista.filter(item => selectedKeys.has(item.idTarefaBpm));
        console.log("------>" + JSON.stringify(listaSelecionados));
        let novaLista = listaSelecionados.map( x => {
            return x.idTarefaBpm;
        });
        console.log("Lista Montada" + JSON.stringify(novaLista));
        return this.fluxoService.transferir(novaLista, this.usuarioDelegadoLogin);

    }

    cleanSucessList(){
        console.log("Limpou ------>");
        this.observacoes = "";
        this.tableRef.state.selectedRowKeys = [];
    }

    cleanErrorList(){
        console.log("Limpou 2 ------>");
        this.observacoes = "";
    }

    cancelarSelecionados(lista){
        console.log("1 ------>" + JSON.stringify(this.tableRef.state.selectedRowKeys));
        const selectedKeys = new Set(this.tableRef.state.selectedRowKeys);
        let listaSelecionados = lista.filter(item => selectedKeys.has(item.idSolicitacaoExibicao));
        console.log("------>" + JSON.stringify(listaSelecionados));
        let novaLista = listaSelecionados.map( x => {
            let novoItem = {
                idTarefa: x.idSolicitacaoExibicao,
                idTarefaBPM: x.idSolicitacaoBpm,
                usuarioResponsavel: x.nomeResponsavel,
                poolEtt: x.poolEtt != null? x.poolEtt: "",
                idFluxo: x.idFluxo != null? x.idFluxo: ""
            }
            return novoItem;
        });
        console.log("Lista Montada" + JSON.stringify(novaLista));
        return this.fluxoService.cancelarFluxo(novaLista, this.observacoes);
    }

    isTarefaComAprovadorExtra(tarefa) {
        return (tarefa.nomeFluxo === "GloboMOTSolicitacaoMOT" && tarefa.definicaoTarefaId === "HT_AvaliacaoSolicitacaoContratacao") ||
            (tarefa.nomeFluxo === "GloboMOTSolicitacaoProrrogacao" && tarefa.definicaoTarefaId === "HT_AvaliacaoSolicitacao")
    }

    verificarAprovacaoEmLote(listaCompleta) {
        this.idSolicitacaoBloqueandoAprovacaoLote = null;
        const selectedKeys = new Set(this.tableRef.state.selectedRowKeys);
        const listaSelecionados = listaCompleta.filter(item => selectedKeys.has(item.idSolicitacaoBpm));

        for (let i = 0; i < listaSelecionados.length; i++) {
            if(!listaSelecionados[i].suportaAprovacao) {
                this.idSolicitacaoBloqueandoAprovacaoLote = listaSelecionados[i].idSolicitacaoExibicao;
                break;
            }
        }

        this.matriculaAprovadoresExtra = [""];
        this.temTarefaQuePodeInserirAprovadorExtra = false;
        const usuarioLogado = this.loginStore.usuarioLogado;
        const comAprovadores = [];
        for (let i = 0; i < listaSelecionados.length; i++) {
            if(this.isTarefaComAprovadorExtra(listaSelecionados[i])) {
                comAprovadores.push(listaSelecionados[i].idSolicitacaoExibicao);
                this.temTarefaQuePodeInserirAprovadorExtra = true;
            }
        }
        this.tarefasComAprovadoresExtra = comAprovadores.join(", ")
    }

    setObservacoes(value) {
        this.observacoes = value;
    }

    aprovarSelecionados(listaCompleta) {
        const selectedKeys = new Set(this.tableRef.state.selectedRowKeys);
        const listaSelecionados = listaCompleta.filter(item => selectedKeys.has(item.idSolicitacaoBpm));
        let matriculaAprovadoresExtra = this.apenasMatriculaAprovadoresExtraValidos
        matriculaAprovadoresExtra.map(String)
        const acoesTarefaBpm = listaSelecionados.map(solicitacao => {
            return {
                idTarefaBpm: solicitacao.idSolicitacaoBpm,
                tipoFluxo: solicitacao.nomeFluxo,
                idSolicitacao: solicitacao.idSolicitacao,
                outcome: "APROVAR",
                comentario: this.observacoes,
                listaAprovadores: matriculaAprovadoresExtra,
                detalhesListagem: solicitacao
            }
        });

        return this.tarefaService.tramitarEmLote(acoesTarefaBpm)
    }

    tramitarTimesheetSelecionados(outcome, listaCompleta, fluxoNovo) {
        const selectedKeys = new Set(this.tableRef.state.selectedRowKeys);
        const listaSelecionados = listaCompleta.filter(item => selectedKeys.has(item.idTarefaBpm));

        //const listaSelecionados = listIgualdadeByAtribute(listaCompleta, this.tableRef.state.selectedRowKeys,"idTarefaBpm" , null);

        const acoesTarefaBpm = {
            listaTarefas: listaSelecionados,
            outcome: outcome,
            comentario: this.observacoes
        };

        return fluxoNovo ? this.timesheetService.tramitarEmLoteV2(acoesTarefaBpm) : this.timesheetService.tramitarEmLote(acoesTarefaBpm);
    }

    aprovarTimesheeetSelecionados(listaCompleta, fluxoNovo) {
        return this.tramitarTimesheetSelecionados("APPROVE", listaCompleta, fluxoNovo);
    }

    enviarTimesheeetSelecionados(listaCompleta, fluxoNovo) {
        return this.tramitarTimesheetSelecionados("ENVIAR_APROVACAO", listaCompleta, fluxoNovo);
    }

    removerAprovadorExtra(index) {
        this.matriculaAprovadoresExtra[index] = null;
    }

    adicionarAprovadorExtra(index) {
        this.matriculaAprovadoresExtra.splice(index + 1, 0, "");
    }

    setMatriculaAprovadoresExtra(value, option, index) {
        this.matriculaAprovadoresExtra[index] = value;
    }

    filtrarEmpregados(input, callback) {
        this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
            if(response && response.length > 0) {
                this.empregadosFiltrados.push(...response);
            }
            callback(null, {
                options: response.map(empregado => {
                    const cpf = !!empregado.cpf ?  " ("+empregado.cpf+")" : "";
                    return {value: input, label: empregado.matricula + " - " + empregado.nome + cpf};
                }),
                complete: false
            });
        }).catch(error => {
            callback(null, {
                options: [],
                complete: false
            });
        });
    }

    //RHFPP-2370-POC-TIMESHEET
    // Debounce para a seleção do usuario a delegar
    filtrarUsuarios = _.debounce(this._filtrarUsuariosPorNome, 1000);

    @computed
    get posicaoPrimeiroAprovadorExtra() {
        this.matriculaAprovadoresExtra.map((empregado, index) => {
            if(empregado !== null) {
                return index;
            }
        });
    }

    @computed
    get quantidadeAprovadoresExtraMostrados() {
        const qnt = [];
        this.matriculaAprovadoresExtra.map(empregado => {
            if(empregado !== null) {
                qnt.push(empregado)
            }
        });
        return qnt.length;
    }

    @computed
    get apenasMatriculaAprovadoresExtraValidos() {
        const matriculasValidas = [];
        if(this.matriculaAprovadoresExtra) {
            this.matriculaAprovadoresExtra.map(aprovador => {
                if(aprovador && aprovador.length === 11){
                    matriculasValidas.push(getByAtribute(this.empregadosFiltrados, aprovador, "cpf").matricula);
                } else if(aprovador) {
                    matriculasValidas.push(parseInt(aprovador));
                }
            });
        }
        return matriculasValidas;
    }
}